import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Раскладочные примитивы (инв.3). app-ui выбирает примитив по useLayout():
//   • SplitPane (desktop) — две панели (список ↔ переписка) с перетаскиваемым разделителем;
//   • StackPane (mobile) — стек панелей с анимацией push/pop «назад» (видна верхняя).
// Компоненты сами не роутят — раскладку панелей собирает app-ui; здесь только примитив раскладки.
// Презентационные: только локальное UI-состояние (ширина сплита, активный индекс стека).
import { useState, useRef, } from 'react';
/** Desktop: две панели + перетаскиваемый вертикальный разделитель. */
export function SplitPane({ start, end, initialStartWidth = 320, minStartWidth = 240, maxStartWidth = 480, }) {
    const [width, setWidth] = useState(initialStartWidth);
    const dragging = useRef(false);
    const root = useRef(null);
    const onPointerDown = (e) => {
        dragging.current = true;
        e.currentTarget.setPointerCapture?.(e.pointerId);
    };
    const onPointerMove = (e) => {
        if (!dragging.current || !root.current)
            return;
        const rect = root.current.getBoundingClientRect();
        const next = Math.min(maxStartWidth, Math.max(minStartWidth, e.clientX - rect.left));
        setWidth(next);
    };
    const onPointerUp = (e) => {
        dragging.current = false;
        e.currentTarget.releasePointerCapture?.(e.pointerId);
    };
    const container = { display: 'flex', height: '100%', minHeight: 0 };
    return (_jsxs("div", { ref: root, "data-split-pane": "", style: container, children: [_jsx("div", { "data-pane": "start", style: { width: `${width}px`, flex: '0 0 auto', minWidth: 0, overflow: 'hidden' }, children: start }), _jsx("div", { "data-split-handle": "", role: "separator", "aria-orientation": "vertical", onPointerDown: onPointerDown, onPointerMove: onPointerMove, onPointerUp: onPointerUp, style: {
                    width: '4px',
                    cursor: 'col-resize',
                    background: 'var(--color-divider)',
                    flex: '0 0 auto',
                } }), _jsx("div", { "data-pane": "end", style: { flex: 1, minWidth: 0, overflow: 'hidden' }, children: end })] }));
}
/** Mobile: стек панелей — видна последняя; анимация push «снизу-вверх»/появления при добавлении. */
export function StackPane({ panes }) {
    const container = { position: 'relative', height: '100%', minHeight: 0, overflow: 'hidden' };
    const topIndex = panes.length - 1;
    return (_jsx("div", { "data-stack-pane": "", "data-depth": panes.length, style: container, children: panes.map((pane, i) => {
            const isTop = i === topIndex;
            const layer = {
                position: 'absolute',
                inset: 0,
                background: 'var(--color-bg)',
                // нижние слои не интерактивны и скрыты (видна только верхняя панель)
                visibility: isTop ? 'visible' : 'hidden',
                pointerEvents: isTop ? 'auto' : 'none',
                animation: isTop && i > 0 ? 'tc-ds-push-in var(--motion-normal) var(--ease-decelerate)' : undefined,
            };
            return (_jsx("div", { "data-stack-layer": i, "data-top": isTop ? '' : undefined, style: layer, children: pane }, i));
        }) }));
}
//# sourceMappingURL=Panes.js.map